export default {"src":"/_next/static/media/ClientLogo.2260f58c.svg","height":30,"width":107,"blurWidth":0,"blurHeight":0};